/*
 * Lazy header navigation.
 *
 * sections/header.liquid renders only the light parts of the menu in the page
 * (top-level links, mobile text links). The mobile thumbnails and the desktop
 * mega-menu panels are fetched here, once per session, from the Section
 * Rendering API (marker path /kg-menu-fetch, see header.liquid) and injected
 * into their placeholders ([data-kg-menu-item][data-kg-part]).
 *
 * Triggers: the first user gesture anywhere on the page (scroll, touch,
 * pointer move, key press) prefetches the menu, so it is normally ready before
 * the burger is tapped or a top-level link is hovered. Interaction inside
 * <main-menu> loads immediately. A late timer is the fallback for visitors who
 * never interact. (Deliberately NOT on idle right after load: that would pull
 * ~1,100 DOM nodes back into the page while Lighthouse is still measuring.)
 */
(function () {
  if (window.__kgMenuLoaderInstalled) return;
  window.__kgMenuLoaderInstalled = true;

  var script = document.querySelector('script[data-kg-menu-loader]');
  var menu = document.querySelector('main-menu[data-kg-menu-lazy]');
  if (!script || !menu) return;

  var url = script.dataset.fetchUrl;
  // Key includes this script's own asset version, so a theme deploy busts the cache.
  var scriptVersion = (script.getAttribute('src') || '').split('?v=')[1] || '0';
  var cacheKey = 'kg-menu:' + script.dataset.sectionId + ':' + script.dataset.version + ':' + scriptVersion;

  // A cached copy is only trusted if it actually contains rendered menu parts.
  function isValidMenuHtml(html) {
    return typeof html === 'string'
      && html.indexOf('Liquid error') === -1
      && /data-kg-part="desktop"[^>]*>\s*<div/.test(html)
      && /data-kg-part="mobile"[^>]*>[\s\S]*?<img/.test(html);
  }
  var promise = null;

  function readCache() {
    try {
      // Drop any stale kg-menu entries from earlier deploys.
      Object.keys(sessionStorage).forEach(function (k) {
        if (k.indexOf('kg-menu:') === 0 && k !== cacheKey) sessionStorage.removeItem(k);
      });
      var html = sessionStorage.getItem(cacheKey);
      if (html && !isValidMenuHtml(html)) { sessionStorage.removeItem(cacheKey); return null; }
      return html;
    } catch (e) { return null; }
  }

  function writeCache(html) {
    try { sessionStorage.setItem(cacheKey, html); } catch (e) { /* quota or private mode */ }
  }

  function inject(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var count = 0;

    doc.querySelectorAll('[data-kg-menu-item][data-kg-part]').forEach(function (src) {
      var selector = '[data-kg-menu-item="' + src.dataset.kgMenuItem + '"][data-kg-part="' + src.dataset.kgPart + '"]';
      document.querySelectorAll(selector).forEach(function (target) {
        if (target.dataset.kgLoaded) return;
        target.innerHTML = src.innerHTML;
        target.dataset.kgLoaded = 'true';
        count += 1;
      });
    });

    // Same as MainMenu.init(): dropdown submenus are rendered open for no-JS.
    document.querySelectorAll('.main-nav .child-nav--dropdown details[open]').forEach(function (details) {
      details.removeAttribute('open');
    });

    // Sidebar-style mega menus bind hover handlers at construction time; bind for injected links.
    var MainMenu = window.customElements && customElements.get('main-menu');
    var t = window.theme;
    if (MainMenu && t && t.device && t.device.hasHover && t.mediaMatches && t.mediaMatches.md) {
      var sidebarLinks = menu.querySelectorAll('.js-sidebar-hover');
      sidebarLinks.forEach(function (el) {
        el.addEventListener('mouseenter', MainMenu.handleSidenavMenuToggle);
      });
      menu.sidebarLinks = sidebarLinks;
      menu.mouseOverSidebarListening = true;
    }

    menu.setAttribute('data-kg-menu-loaded', 'true');
    document.dispatchEvent(new CustomEvent('kg:header-menu-loaded', { detail: { count: count } }));
    return count;
  }

  function load() {
    if (promise) return promise;

    promise = new Promise(function (resolve, reject) {
      var cached = readCache();
      if (cached) { resolve(cached); return; }

      fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Menu fetch failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (!isValidMenuHtml(html)) throw new Error('Menu fetch returned an incomplete menu');
          writeCache(html);
          resolve(html);
        })
        .catch(reject);
    })
      .then(inject)
      .catch(function (error) {
        promise = null; // allow a retry on the next interaction
        if (window.console) console.warn('[KG] header menu load failed', error);
      });

    return promise;
  }

  window.KGLoadHeaderMenu = load;

  ['touchstart', 'pointerdown', 'mouseenter', 'focusin'].forEach(function (type) {
    menu.addEventListener(type, function () { load(); }, { once: true, passive: true });
  });

  var gestureTypes = ['scroll', 'touchstart', 'pointermove', 'keydown', 'wheel'];
  function onFirstGesture() {
    gestureTypes.forEach(function (type) { window.removeEventListener(type, onFirstGesture); });
    var ric = window.requestIdleCallback || function (cb) { setTimeout(cb, 100); };
    ric(function () { load(); }, { timeout: 1500 });
  }
  gestureTypes.forEach(function (type) {
    window.addEventListener(type, onFirstGesture, { once: true, passive: true });
  });

  function lateFallback() { setTimeout(function () { load(); }, 12000); }
  if (document.readyState === 'complete') lateFallback();
  else window.addEventListener('load', lateFallback);
})();
